import React from "react";
import { MdLogout } from "react-icons/md";
import axiosapi from "../config/axiosConfig";

const isProduction = process.env.NODE_ENV === "production";
const LOGIN_URL = isProduction
  ? "https://gestionterritoriallr.com.ar/"
  : "https://pxh0r724-5173.brs.devtunnels.ms/";

const LogoutButton = () => {
  const handleLogout = async () => {
    try {
      // Llamar al endpoint /api/logout para borrar la cookie session
      await axiosapi.post(
        "/api/logout",
        {},
        {
          withCredentials: true,
        }
      );

      // Limpiar estado local (el redirect descarta el estado de Redux)
      localStorage.removeItem("token");
      localStorage.removeItem("userEmail");

      // Redirigir a la página principal de login centralizado
      window.location.href = LOGIN_URL;
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
      // Aunque falle, redirigir igual
      localStorage.removeItem("token");
      localStorage.removeItem("userEmail");
      window.location.href = LOGIN_URL;
    }
  };

  return (
    <div>
      <button
        onClick={handleLogout}
        className="logout-link"
        aria-label="Cerrar sesión"
      >
        <MdLogout
          style={{ color: "red", fontSize: "30px", cursor: "pointer" }}
        />
      </button>
    </div>
  );
};

export default LogoutButton;
